import React from 'react';

import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';
import {WidthItem} from 'src/components/width-item';

import {Group} from '@pb/kit-component-group';


export const AccountSettingsSkeleton = () => (
    <Group direction="v">
        <FormSectionSkeleton labelWidth={155}>
            <Group alignItems="start" direction="v">
                <Group>
                    <SkeletonItem width={14} height={14}/>
                    <SkeletonItem width={100} height={18}/>
                </Group>
                <Group alignItems="start">
                    <WidthItem width={300}>
                        <FormItemSkeleton labelWidth={85}>
                            <Group direction="v" gap="s">
                                <Group>
                                    <SkeletonItem width={14} height={14}/><SkeletonItem width={50} height={14}/>
                                </Group>
                                <Group>
                                    <SkeletonItem width={14} height={14}/><SkeletonItem width={55} height={14}/>
                                </Group>
                            </Group>
                        </FormItemSkeleton>
                    </WidthItem>
                    <WidthItem width={300}>
                        <FormItemSkeleton labelWidth={90}>
                            <Group direction="v" gap="s">
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={50} height={14}/>
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={50} height={14}/>
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={50} height={14}/>
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={50} height={14}/>
                            </Group>
                        </FormItemSkeleton>
                    </WidthItem>
                    <WidthItem width={300}>
                        <FormItemSkeleton labelWidth={60}>
                            <Group direction="v" gap="s">
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={150} height={14}/>
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={150} height={14}/>
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={150} height={14}/>
                                <SkeletonItem width={14} height={14}/><SkeletonItem width={150} height={14}/>
                            </Group>
                        </FormItemSkeleton>
                    </WidthItem>
                </Group>
            </Group>
        </FormSectionSkeleton>
        <FormSectionSkeleton labelWidth={155}>
            <FormItemSkeleton labelWidth={300}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
        </FormSectionSkeleton>
    </Group>
);
